import * as React from "react";

export const DropdownContext = React.createContext(() => {});
